import React from "react";

import { Phone, Check, ShieldCheck } from "lucide-react";

import "./Header.css";

const Header = () => {
  const benefits = [
    "Rút được toàn bộ hạn mức thẻ",
    "Thủ tục đơn giản, không giữ thẻ",
    "Bảo mật thông tin tuyệt đối",
    "Hỗ trợ tại nhà, văn phòng, mọi khu vực",
  ];

  return (
    <section className="hero">
      <div className="hero-container">
        {/* LEFT CONTENT */}

        <div className="hero-content">
          {/* BADGE */}

          <div className="hero-badge">DỊCH VỤ THẺ TÍN DỤNG</div>

          {/* TITLE */}

          <h1 className="hero-title">
            RÚT TIỀN NHANH
            <br />
            PHÍ CHỈ TỪ
            <span className="hero-price"> 1,1%</span>
          </h1>

          {/* SUBTITLE */}

          <p className="hero-subtitle">
            Nhận tiền sau 3 phút - Hỗ trợ 24/7 - Có mặt tận nơi
          </p>

          {/* BENEFITS */}

          <div className="hero-benefits">
            {benefits.map((item, index) => (
              <div className="hero-benefit" key={index}>
                <span className="benefit-check">
                  <Check size={14} strokeWidth={3} />
                </span>

                <span>{item}</span>
              </div>
            ))}
          </div>

          {/* CALL BUTTON */}

          <a href="tel:0941342598" className="hero-call">
            <Phone size={20} fill="white" />

            <span>GỌI NGAY: 0941 342 598</span>
          </a>

          {/* CALL NOTE */}

          <p className="hero-call-note">Tư vấn miễn phí 24/7</p>
        </div>

        {/* RIGHT IMAGE */}

        <div className="hero-visual">
          <img
            src="/banner.webp"
            alt="Dịch vụ thẻ tín dụng"
            className="hero-image"
          />
        </div>
      </div>

      {/* BOTTOM TRUST */}

      <div className="hero-bottom">
        <ShieldCheck size={16} />

        <span>Thông tin khách hàng được bảo mật</span>
      </div>
    </section>
  );
};

export default Header;
